import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";


export const addProductEnquiry = async (data) => {
  try {
    return await postData(`/website/product_enquiry/add`, data);
  } catch (error) {
    console.log(error);
  }
};


export const addContactUs = async (data) => {
  try {
    return await postData(`/website/contactus/add`, data);
  } catch (error) {
    console.log(error);
  }
};
